export enum AttendanceStatus {
  PRESENT = "PRESENT",
  ABSENT_UNEXCUSED = "ABSENT_UNEXCUSED",
  ABSENT_EXCUSED = "ABSENT_EXCUSED",
  LATE = "LATE",
  LEFT_EARLY = "LEFT_EARLY",
}
